// Property names are used for event tracking and AI naming features.
// Can add new features but should not remove or rename existing ones.
export interface AIFeatures {
  iqBoost: boolean;
  iqBoostWidget: boolean;
  summarization: boolean;
  meetingPreparation: boolean;
  smartCapture: boolean;
  outlook: boolean;
}

export type AIUserData = {
  aiFeaturesEnabled: AIFeatures;
};

export type AIAdminData = {
  creditsUsed: number;
  creditsTotal: number;
  aiFeaturesEnabled: AIFeatures;
};

export interface AiUserDataGroup {
  admin: AIAdminData;
  user: AIUserData;
  isAdmin: boolean;
}

export const AI_CONFIG_DEFAULT_FEATURES: AIFeatures = {
  iqBoost: true,
  iqBoostWidget: false,
  summarization: true,
  meetingPreparation: true,
  smartCapture: false,
  outlook: false,
};

export const AI_CONFIG_DEFAULT_USER_DATA: AIUserData = {
  aiFeaturesEnabled: AI_CONFIG_DEFAULT_FEATURES,
};

export const AI_CONFIG_DEFAULT_ADMIN_DATA: AIAdminData = {
  aiFeaturesEnabled: AI_CONFIG_DEFAULT_FEATURES,
  creditsUsed: 0,
  creditsTotal: 1000000,
};

type StoredData<T> = Partial<T> | null | undefined;

const AI_FEATURES_OFF: AIFeatures = {
  iqBoost: false,
  iqBoostWidget: false,
  summarization: false,
  meetingPreparation: false,
  smartCapture: false,
  outlook: false,
};

function withFeatureDefaults(stored: StoredData<Pick<AIUserData, 'aiFeaturesEnabled'>>): AIFeatures {
  return stored ? { ...AI_FEATURES_OFF, ...stored.aiFeaturesEnabled } : { ...AI_CONFIG_DEFAULT_FEATURES };
}

export function withAiUserDataDefaults(stored: StoredData<AIUserData>): AIUserData {
  return {
    aiFeaturesEnabled: withFeatureDefaults(stored),
  };
}

export function withAiAdminDataDefaults(stored: StoredData<AIAdminData>): AIAdminData {
  return {
    creditsUsed: stored?.creditsUsed ?? AI_CONFIG_DEFAULT_ADMIN_DATA.creditsUsed,
    creditsTotal: stored?.creditsTotal ?? AI_CONFIG_DEFAULT_ADMIN_DATA.creditsTotal,
    aiFeaturesEnabled: withFeatureDefaults(stored),
  };
}
